export const config = {
    type: 'RICH_TEXT',
    title: '富文本',
    defaultProps: {
        content: '<p>这是一段富文本内容</p>',
        style: {
            backgroundColor: "transparent",
            borderRadius: "0px",
            marginBottom: "0px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px",
            minHeight: "100px",
            padding: "15px",
        }
    },
    preview: {
        style: {
            padding: '8px'
        },
        items: [
            {
                style: {
                    width: '90%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)',
                    marginBottom: '6px'
                }
            },
            {
                style: {
                    width: '80%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)',
                    marginBottom: '6px'
                }
            },
            {
                style: {
                    width: '70%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)'
                }
            }
        ]
    }
};